import React from "react";
import "./Header.css";

const Header = ({ isOfferPage }) => {
  console.log("isOfferPage", isOfferPage);
  const logoSrc = isOfferPage
    ? "/assets/img/newLogo.png"
    : "/assets/img/Footer logo.png";

  const hamburgerSrc = isOfferPage
    ? "/assets/img/Hamburger menu.svg"
    : "/assets/img/lp1hamberger.png";

  return (
    <header className="header">
      <img src={logoSrc} alt="Digit Money Logo" className="logo-img" />
      <button className="menu-btn" aria-label="Menu">
       
      </button>
    </header>
  );
};

export default Header;
